import { Button } from "antd";
import { Link, useLocation, useParams } from "react-router-dom";
import BackButtonIcon from "../../../assets/icons/BackButtonIcon";
import TopCard from "../../../components/common/TopCard";
import ContactInfo from "../../../components/Customers/ContactInfo";
import TableCard from "../../../components/Customers/TableCard";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { backLink } from "../../../utils/utils";

enum Status {
  Approved = "status-success",
  Pending = "status-warning",
  Cancelled = "status-danger",
}

export default function CustomerDetails() {
  const location = useLocation();
  const { viewId } = useParams();

  return (
    <SidebarLayout title={`Customer Details #${viewId}`}>
      <TopCard
        leftChildren={
          <Link to={backLink(location.pathname, 2)}>
            <Button className="normal-dark-button" icon={<BackButtonIcon />}>
              Back
            </Button>
          </Link>
        }
      >
        <Button
          type="primary"
          // onClick={() =>
          //   handleOpen({
          //     type: "Update",
          //   })
          // }
        >
          Update
        </Button>
      </TopCard>

      <div className="mb-6 grid md:grid-cols-2 gap-6">
        <ContactInfo />
        <div className="space-y-6">
          <TableCard type="DIGIGO" />
          <TableCard type="TICKETING" />
        </div>
      </div>
    </SidebarLayout>
  );
}
